import OpenLetter from "../openletter/OpenLetter";

export default function Home() {
  return (
    <div>
      <OpenLetter />
    </div>
  );
}
